export const HOST_API_KEY = process.env.REACT_APP_HOST_API_KEY || ''

export const EVENTZ_API = process.env.REACT_APP_EVENTZ_API_URL || ''
export const EDITTOR_WEB_URL = process.env.REACT_APP_EDITTOR_WEB_URL || ''

export const MEMBERSHIP = {
  PROVIDER_ID: process.env.REACT_APP_MEMBERSHIP_PROVIDER_ID,
  APP_URL: process.env.REACT_APP_MEMBERSHIP_APP_URL,
  API_URL: process.env.REACT_APP_MEMBERSHIP_API_URL,
}

export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
}

export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN

export const COGNITO_API = {
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
}

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
}

export const MAP_API = process.env.REACT_APP_MAPBOX_API

export const PHOEBUS_API = {
  baseUrl: process.env.REACT_APP_PHOEBUS_API_BASE_URL,
}

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 64,
  H_MAIN_DESKTOP: 88,
  H_DASHBOARD_DESKTOP: 10,
  H_DASHBOARD_DESKTOP_OFFSET: 0,
}

export const NAV = {
  W_BASE: 260,
  W_DASHBOARD: 280,
  W_DASHBOARD_MINI: 88,
  //
  H_DASHBOARD_ITEM: 48,
  H_DASHBOARD_ITEM_SUB: 36,
  //
  H_DASHBOARD_ITEM_HORIZONTAL: 32,
}

export const ICON = {
  NAV_ITEM: 24,
  NAV_ITEM_HORIZONTAL: 22,
  NAV_ITEM_MINI: 22,
}
